<!--
 * @Descripttion: 
 * @version: 
 * @Author: xzx
 * @Date: 2021-01-07 16:59:48
 * @LastEditors: xzx
 * @LastEditTime: 2021-01-11 10:49:07
-->
<template>
    <div style="width: 100%; height: 300px;display: inline-block;">
        <div :ref="setRef" style="width:100%; height:100%;"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import { computed,  onMounted, onUnmounted, reactive, watchEffect } from "vue";
import { useStore } from 'vuex'

export default {
    name: "tw-histogram",
    
    setup(props) {
        let myRef;
        let myChart;

        // 主题
        const store = useStore()
        const isDark = computed(() => {
            return store.state.isDark
        })

        const setRef = el => {
            myRef = el;
        }

        // 接口数据：http://api.jeecg.com/mock/26/bar
        let mockJson = reactive({"data":{"categories":["苹果","三星","小米","oppo","vivo"],"series":[{"name":"手机品牌","data":[10087,34087,23087,54087,34087]}]}});

        const dataInit = function() {
            if(mockJson && mockJson.data && mockJson.data.series){
                mockJson.data.series.forEach(function(val){
                    val.type = 'bar';
                    val.label = {
                        show: true, //开启显示
                        position: 'top', //在上方显示
                        textStyle: { //数值样式
                            color: isDark.value ? '#ebedef' : '#495057',
                            fontSize: '16'
                        }
                    };
                    if(props.barWidth){
                        val.barWidth = props.barWidth;   //设置柱子宽度，单位为px
                    }
                })
            }
        }

        const echartInit = () =>{
            // echarts.registerTheme('tw_dark', twDark)
            myChart = echarts.init(myRef);
            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: props.title,
                    textStyle: {
                        color: isDark.value ? '#ebedef' : '#495057'
                    }
                },
                legend: {
                    show: props.legendShow,
                    textStyle: {
                        color: isDark.value ? '#ebedef' : '#495057'
                    }
                },
                tooltip: {
                    show: true,
                    trigger: 'axis'
                },
                series: mockJson.data.series
            };

            if (props.direction === 'vertical') {
                // 纵向
                Object.assign(option, {
                    xAxis: {
                        show: true,
                        data: mockJson.data.categories,
                        axisLabel: {
                            color: isDark.value ? '#ebedef' : '#495057'
                        }
                    },
                    yAxis: {
                        show: true,
                        splitLine: {
                            show: true,
                            lineStyle: {
                                // 使用深浅的间隔色
                                color: [ !isDark.value ? '#ebedef' : '#495057' ],
                                type: 'dashed'
                            }
                        },
                        axisLabel: {
                            color: isDark.value ? '#ebedef' : '#495057'
                        }
                    }
                })
            } else {
                // 横向
                option.series[0].label = {
                    normal: {
                        show: true,
                        position: 'right'
                    }
                }
                Object.assign(option, {
                    xAxis: {
                        show: true,
                        splitLine: {
                            show: true,
                            lineStyle: {
                                // 使用深浅的间隔色
                                color: [ !isDark.value ? '#ebedef' : '#495057' ],
                                type: 'dashed'
                            }
                        },
                        axisLabel: {
                            color: isDark.value ? '#ebedef' : '#495057'
                        }
                    },
                    yAxis: {
                        show: true,
                        data: mockJson.data.categories,
                        axisLabel: {
                            color: isDark.value ? '#ebedef' : '#495057'
                        }
                    }
                })
            }

            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        }

        // 窗口改变大小时需要刷新饼图
        const onResize = function() {
            setTimeout(() => {
                myChart.resize()
            }, 100);
        }

        onMounted(()=>{
            window.addEventListener("resize", onResize)

            watchEffect(() => {
                const data = props.data_source && props.data_source.datas

                if (data) {
                    if (data.data && data.data.categories && data.data.series) {
                        mockJson = reactive(props.data_source.datas)
                    } else {
                        if (Array.isArray(data) && props.caption_name && props.value_name) {
                            const chartData = { data: { categories: [], series:[{ name: props.series_name, data: [] }]}}
                            data.forEach(el => {
                                chartData.data.categories.push(el[props.caption_name])
                                chartData.data.series[0].data.push(el[props.value_name])
                            })
                            mockJson = reactive(chartData)
                        } else {
                            // 属性未选完，不用提示错误
                            // ElMessage.error('柱状图：请检查【数据源】数据格式');
                            mockJson = reactive({
                                data: {
                                    categories: [],
                                    series: []
                                }
                            })
                        }
                    }
                }
                dataInit()
                echartInit()
            })
        })

        onUnmounted(() => {
            document.removeEventListener('resize', onResize, true)
        })

        return {
            setRef,
            echartInit
        };

    },

    props: {
        title: String,
        legendShow: {
            type: Boolean,
            default: true
        },
        barWidth: Number,
        series_name: {
            type: String,
            default: '',
        },
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        caption_name: {
            type: String,
            default: ''
        },
        value_name: {
            type: String,
            default: ''
        },
        direction: {
            type: String,
            default: 'vertical'
        }
    }
  }
</script>

<style>

</style>